import { useFormikContext } from 'formik';
import { DropzoneOptions, useDropzone } from 'react-dropzone';

interface UseDropZoneInitProps extends DropzoneOptions {
  name: string;
}

export function useDropZoneInit<T>(props: UseDropZoneInitProps) {
  const { name, ...rest } = props;
  // TODO: fix type, add type string
  const { setFieldValue, values } = useFormikContext<{ [key: string]: any[] }>();
  const images: T[] = values[name] ?? [];

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setFieldValue(name, acceptedFiles);
    },
    ...rest,
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/webp': ['.webp'],
      ...rest.accept,
    },
  });

  return {
    acceptedFiles,
    rootProps: { ...getRootProps({ className: 'dropzone' }) },
    inputProps: { ...getInputProps() },
    setFieldValue,
    images,
  };
}
